// Schema.org Local Business JSON-LD for SEO
// This helps Google understand your business better

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "SportsActivityLocation",
  "name": "Performove Training_LAB",
  "image": "https://performoverimini.it/logo-performove.png",
  "@id": "https://performoverimini.it",
  "url": "https://performoverimini.it",
  "telephone": "+39-347-4955028",
  "email": "performove.rimini@gmail.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Viale Tripoli 216/B",
    "addressLocality": "Rimini",
    "addressRegion": "Emilia-Romagna",
    "postalCode": "47921",
    "addressCountry": "IT"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 44.063324,
    "longitude": 12.568247
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "07:00",
      "closes": "21:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "08:00",
      "closes": "14:00"
    }
  ],
  "sameAs": [
    "https://instagram.com/performove_rimini",
    "https://facebook.com/performove_rimini"
  ],
  "priceRange": "€€",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "reviewCount": "4"
  },
  "description": "Centro specializzato di personal training a Rimini. Allenamenti personalizzati 1:1, trasformazioni documentate, HIIT, functional training e return to play. Zona Viale Tripoli."
};
